import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function AddSupplier() {
  const [supplierName, setSupplierName] = useState("");
  const [supplierAddress, setSupplierAddress] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [email, setEmail] = useState("");
  const [generatedSupplierCode, setGeneratedSupplierCode] = useState(null);
  const [organization, setOrganization] = useState("");
  const [location, setLocation] = useState("");
  const [contact_person, setContactPerson] = useState("");
  const [BRN, setBRN] = useState("");
  const [userRole, setUserRole] = useState("");

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const token = sessionStorage.getItem("token");
        if (!token) {
          toast.error("Authentication token is missing. Please log in again.");
          return;
        }

        const userResponse = await axios.get(`${API_BASE_URL}/users/specific`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setUserRole(userResponse.data.role);
        setLocation(userResponse.data.location);
        setOrganization(userResponse.data.organization);
      } catch (error) {
        console.error("Error fetching user data:", error);
        toast.error("Error fetching user data.");
      }
    };

    fetchUserData();
  }, []);

  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleAddSupplier = async () => {
    if (!supplierName) return toast.error("Supplier Name is required.");
    if (!email || !isValidEmail(email)) return toast.error("Enter a valid email.");
    if (!mobileNo) return toast.error("Mobile number is required.");

    const formData = {
      supplier_name: supplierName,
      supplier_address: supplierAddress,
      Contact_person: contact_person,
      mobile_no: mobileNo,
      email,
      BRN,
      organization,
      location,
    };

    try {
      const token = sessionStorage.getItem("token");
      if (!token) {
        toast.error("Authentication token is missing. Please log in again.");
        return;
      }

      const response = await axios.post(`${API_BASE_URL}/suppliers/add`, formData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      toast.success(response.data.message || "Supplier added successfully!");
      setGeneratedSupplierCode(response.data.supplier?.supplier_code);
    } catch (error) {
      if (error.response?.status === 400) {
        const { message, details } = error.response.data;
        if (details?.organization_name) {
          toast.error(`${message} (Organization: ${details.organization_name})`);
        } else {
          toast.error(message || "Error adding supplier.");
        }
      } else {
        toast.error("Failed to add supplier. Please try again.");
      }
    }
  };

  return (
    <div className="container mx-auto p-6">
      <div className="bg-white rounded-lg shadow-lg p-6 mt-4">
        <h2 className="text-2xl font-bold text-green-700 mb-6">Add Supplier</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="mb-4">
            <label className="block text-gray-700 mb-2">Supplier Name</label>
            <input
              type="text"
              className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
              placeholder="Enter supplier name"
              value={supplierName}
              onChange={(e) => setSupplierName(e.target.value)}
            />
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 mb-2">Supplier Address</label>
            <input
              type="text"
              className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
              placeholder="Enter supplier address"
              value={supplierAddress}
              onChange={(e) => setSupplierAddress(e.target.value)}
            />
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 mb-2">Contact Person</label>
            <input
              type="text"
              className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
              placeholder="Enter supplier address"
              value={contact_person}
              onChange={(e) => setContactPerson(e.target.value)}
            />
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 mb-2">Mobile No</label>
            <input
              type="text"
              className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
              placeholder="Enter mobile number"
              value={mobileNo}
              onChange={(e) => setMobileNo(e.target.value)}
            />
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 mb-2">BRN</label>
            <input
              type="text"
              className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
              placeholder="Enter mobile number"
              value={BRN}
              onChange={(e) => setBRN(e.target.value)}
            />
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 mb-2">Email</label>
            <input
              type="text"
              className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
              placeholder="Enter email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
        </div>

        {generatedSupplierCode && (
          <div className="mt-4 p-4 bg-gray-100 rounded-lg">
            <p className="text-green-700 font-bold">
              Generated Supplier Code: {generatedSupplierCode}
            </p>
          </div>
        )}
      </div>

      <div className="flex space-x-4 mt-6">
        <button
          className="px-6 py-3 bg-green-700 text-white rounded-lg hover:bg-green-800"
          onClick={handleAddSupplier}
        >
          Add Supplier
        </button>
      </div>
    </div>
  );
}

export default AddSupplier;
